import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getCustomerTagSales({
    date, interval, endDate = null, customerTagId = null,
  }) {
    return axiosIns.get(
      '/v2/statistics/customer_tag_sales',
      {
        params: snakecaseKeys({
          date,
          interval,
          endDate,
          customerTagId,
        }),
      },
    )
  },
}
